import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { NavLink } from 'react-router-dom';

export class SecretariatShortCutWidget extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            caller: props.Caller,
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/dashboard/widget/get", { name: 'SecretariatShortCutWidget' })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false,
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <ul className="row g-gs preview-icon-svg no-drag-widget">
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/letters/my/filter/3" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#e5e1f5"}}>
                    <span>{this.state.data.newCount} نامه</span>
                    <span className="preview-icon-name">جدید در کارتابل</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/letters/my/filter/1" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#f0fff5" }}>
                    <span>{this.state.data.waitToResponseCount} نامه</span>
                    <span className="preview-icon-name">نیاز به پاسخ</span>
                </NavLink>
            </li>
            <li className="col-lg-4 col-6 col-sm-4">
                <NavLink to="/letters/all/my/filter/2" className="preview-icon-box card card-bordered" style={{ "backgroundColor": "#fff0f0" }}>
                    <span>{this.state.data.draftCount} نامه</span>
                    <span className="preview-icon-name">پیش نویس</span>
                </NavLink>
            </li>
        </ul>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.renderForm()
            ];

        return contents;
    }
}